module.exports = __webpack_public_path__ + "static/the-diamond-age-50f0379fe253673186b5d5f613c4c098.jpg";